import { Box, Stack } from '@mui/joy'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Alert } from '~/shared/ui/Alerts'
import { Button } from '~/shared/ui/Buttons'
import { CheckFileIcon } from '~/shared/ui/Icons'
import { Modal } from '~/shared/ui/Modal'

type ActiveModalProps = {
  isShow: boolean
  onOk: () => Promise<void>
  onCancel: () => void
  title?: string
  buttonTitle?: string
}

export const ActiveModal = ({
  isShow,
  onOk,
  onCancel,
  title,
  buttonTitle,
}: ActiveModalProps) => {
  const { t } = useTranslation()
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)

  const handleSuccess = useCallback(async () => {
    try {
      setIsSubmitting(true)
      await onOk()
      onCancel()
    } finally {
      setIsSubmitting(false)
    }
  }, [onCancel, onOk])

  return (
    <Modal
      isShow={isShow}
      onCancel={isSubmitting ? undefined : onCancel}
      dialogProps={{
        sx: {
          minWidth: '600px',
          maxWidth: '600px',
        },
      }}
    >
      <Alert variant='info' sx={{ margin: '44px 0 24px 0' }}>
        {title || `${t('button.activate the contract')} ?`}
      </Alert>
      <Box sx={{ padding: '4px' }}>
        <Stack direction='row' justifyContent='space-between' spacing={2}>
          <Button
            variant='gray'
            onClick={onCancel}
            disabled={isSubmitting}
            fullWidth
          >
            {t('button.cancel')}
          </Button>
          <Button
            variant='brand'
            loading={isSubmitting}
            fullWidth
            startDecorator={<CheckFileIcon />}
            onClick={handleSuccess}
          >
            {buttonTitle || t('button.activate')}
          </Button>
        </Stack>
      </Box>
    </Modal>
  )
}
